import { useDispatch } from 'react-redux'
import { actions } from '../../EmailSettingsState'
import * as S from './EmailSetupButton.styles'
import { useGoogleLogin } from '@react-oauth/google'

const EmailSetupButton = () => {
  const dispatch = useDispatch()

  const googleLogin = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      await dispatch(actions.login({ codeResponse: codeResponse.code }))
    },
    flow: 'auth-code',
    scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/gmail.send',
  })

  return (
    <>
      <S.CustomButton
        title='Configurar E-mail'
        id='setupButton'
        type='submit'
        testId='button-setup-email'
        bgColor='blue'
        hoverColor='darkBlueHover'
        letterColor='white'
        onClick={googleLogin}
      />
    </>
  )
}

export default EmailSetupButton
